<template>
  <div>
    <div class="navbar-wrapper">
      <Button
        flat
        icon
        class="menu-btn"
        @click="activeSidebar = true"
      >
        <i class='bx bx-menu'></i>
      </Button>
      <router-link to="/" class="navbar-link navbar-title">
        <h3>{{ config.blogTitle }}</h3>
      </router-link>
      <nav class="navbar-items">
        <router-link
          v-for="(link, index) in links"
          :key="index"
          :to="link.url"
          class="navbar-item"
          :class="{ active: active.name === link.name }"
        >
          {{ link.name }}
        </router-link>
      </nav>
      <div class="navbar-right">
        <ToggleSwitch
          :modelValue="dark"
          @update:modelValue="changeTheme"
        >
          <template #handle="{ value }">
            <i :class="value ? 'bx bxs-sun' : 'bx bxs-moon'"></i>
          </template>
        </ToggleSwitch>
      </div>
    </div>

    <Drawer
      v-model:visible="activeSidebar"
      :header="config.blogTitle"
    >
      <nav class="sidebar-items">
        <router-link
          v-for="(link, index) in links"
          :key="index"
          :to="link.url"
          class="sidebar-item"
          @click="activeSidebar = false"
        >
          {{ link.name }}
        </router-link>
      </nav>
    </Drawer>

    <div style="margin-bottom: 100px"></div>
  </div>
</template>

<script>
import Button from 'primevue/button'
import Drawer from 'primevue/drawer'
import ToggleSwitch from 'primevue/toggleswitch'

let Config = null
try {
  Config = require('@/../posts/data/config.json')
} catch (e) {
  Config = require('@/defaults/config.json')
}

export default {
  name: 'Navbar',
  components: {
    Button,
    Drawer,
    ToggleSwitch
  },
  data: () => {
    return {
      config: Config.config,
      activeSidebar: false,
      dark: false,
      links: [
        {
          name: '主页',
          url: '/'
        },
        {
          name: '文章',
          url: '/posts'
        },
        {
          name: '项目',
          url: '/projects'
        },
        {
          name: '链接',
          url: '/links'
        },
        {
          name: '标签',
          url: '/tags'
        },
        {
          name: '关于自己',
          url: '/about'
        }
      ]
    }
  },
  methods: {
    changeTheme: function (isDark) {
      // ToggleSwitch v-model 已经更新了 dark,这里只需同步 body attribute
      // 保留 vs-theme attribute 兼容既有 CSS,PrimeVue 主题另由 preset 控制
      this.dark = isDark
      document.getElementsByTagName('body')[0].setAttribute('vs-theme', isDark ? 'dark' : 'light')
    }
  },
  computed: {
    active: function () {
      const cur = this.$route.path
      let ret = {
        name: null,
        url: null
      }
      for (let i = 0; i < this.links.length; i++) {
        if (this.links[i].url === cur) ret = this.links[i]
      }
      return ret
    }
  }
}
</script>

<style scoped>
.navbar-wrapper {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background: var(--p-menubar-background, #fff);
  border-bottom: 1px solid var(--p-menubar-border-color, #eee);
  position: sticky;
  top: 0;
  z-index: 100;
}

.menu-btn {
  margin-right: 20px;
}

.navbar-title {
  text-decoration: none;
  color: inherit;
  margin-right: 30px;
}

.navbar-items {
  display: flex;
  gap: 20px;
  flex: 1;
}

.navbar-item {
  text-decoration: none;
  color: var(--p-text-color, #333);
  padding: 6px 12px;
  border-radius: 4px;
  transition: background 0.2s;
}

.navbar-item:hover,
.navbar-item.active {
  background: var(--p-menubar-item-active-background, rgba(0,0,0,0.05));
}

.navbar-right {
  margin-left: auto;
}

.sidebar-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sidebar-item {
  text-decoration: none;
  color: inherit;
  padding: 10px 12px;
  border-radius: 4px;
}

.sidebar-item:hover {
  background: rgba(0,0,0,0.05);
}
</style>
